import PropTypes from 'prop-types';

import withRequestId from 'core/hocs/withRequestId';

import BaseTopic from './BaseTopic';
import TopicsMeta from './TopicsMeta';
import QuickEditLink from './QuickEditLink';

/**
 * Загружает из апи данные для статьи на основе параметра `topic_link` который
 * должен прийти в `match` предоставляемый `react-router`.
 *
 * @author Anton Ignatov <a.ignatov@rambler-co.ru>
 */
function Topic(props) {
  const {
    children,
    content,
    titleBuilder,
    descriptionBuilder,
    hideAmpLink,
    requestId,
    disableMeta,
  } = props;

  if (!content) return null;

  return (
    <>
      {!disableMeta && (
        <TopicsMeta
          content={content}
          titleBuilder={titleBuilder}
          descriptionBuilder={descriptionBuilder}
          hideAmpLink={hideAmpLink}
        />
      )}
      <BaseTopic
        content={content}
        key={content.id}
        requestId={requestId}
      >
        {children}
      </BaseTopic>
      <QuickEditLink topicId={content.id} />
    </>
  );
}

Topic.propTypes = {
  /**
   * Данные топика со всеми зависимостями `include=all` полученные от дата-провайдера встроенного в компонент.
   */
  content: PropTypes.object,
  /**
   * Функция для генерации тайтла станицы.
   * Используется для сложных SEO шаблонов, зависящих от рубрики, типа топика, пагинации и прочего.
   */
  titleBuilder: PropTypes.func,
  /**
   * Функция для генерации описания страницы.
   * Используется для сложных SEO шаблонов, зависящих от рубрики, типа топика, пагинации и прочего.
   */
  descriptionBuilder: PropTypes.func,
  /**
   * Для скрытия амп-ссылки в мета-тегах `link[rel='amphtml']`.
   */
  hideAmpLink: PropTypes.bool,
  /**
   * Используется в BaseTopic.
   *
   * Получаем из withRequestId и пробрасываем дальше.
   *
   * Получать `requestId` из HOC в BaseTopic нельзя, из-за того что BaseTopic перерендерится раньше и со старым топиком.
   */
  requestId: PropTypes.string,
  /**
   * Отключает TopicMeta
   */
  disableMeta: PropTypes.bool,
};

const TopicWithHOCs = withRequestId(Topic);

TopicWithHOCs.displayName = 'Topic';

export { Topic as StorybookComponent };
export { default as TopicsMeta }  from './TopicsMeta';
export { StorybookComponent as BaseTopic }  from './BaseTopic';
export { StorybookComponent as QuickEditLink } from './QuickEditLink';

export default TopicWithHOCs;
